export const educationData = [
    {
        id: 1,
        institution: 'AWS Certified Solutions Architect',
        course: 'Professional Certification',
        startYear: '2020',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Kubernetes Administrator (CKA)',
        course: 'Technical Certification',
        startYear: '2021',
        endYear: '2024'
    },
    {
        id: 3,
        institution: 'Queensland University of Technology',
        course: 'Bachelor of Computer & Software Engineer / Business Finance',
        startYear: '2015',
        endYear: '2019'
    },
]